module.exports = __webpack_public_path__ + "static/media/affinity-new.2a883245.png";